import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface IntegrationsState {
  cardView: string;
  selectedIntegration: string;

  setCardView: (view: string) => void;
  updateSelectedIntegration: (integration: string) => void;
}

const useIntegrationsStore = create<IntegrationsState>()(
  devtools(
    (set) => ({
      cardView: 'grid',
      selectedIntegration: '',

      setCardView: (view) => set({ cardView: view }),
      updateSelectedIntegration: (integration) =>
        set({
          selectedIntegration: integration,
        }),
    }),
    {
      name: 'IntegrationsStore',
    }
  )
);

export default useIntegrationsStore;
